module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fields) ? _c('div', {
    staticClass: "module_container"
  }, [_c('div', {
    staticClass: "module_shadow"
  }, [_c('div', {
    staticClass: "module_header row no_wrap align_center justify_between"
  }, [_c('div', {
    staticClass: "span_auto"
  }, [_c('h2', [_vm._v(_vm._s(_vm.fields.page_title))])])]), _vm._v(" "), _c('div', {
    staticClass: "module_copy row"
  }, [_c('div', {
    staticClass: "span_12",
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.fields.page_content))
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d098c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dash_page/dash_page.vue
// module id = 624
// module chunks = 1